<div *ngFor="let item of proLogoInfo | keyvalue">{{item.key}} : {{item.value}}</div>